export default __webpack_public_path__ + "static/media/Cryptocurrency_Logo.dfead2b3.svg";